import { Flex, Text, ThemeIcon } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

type ModalWarningContentProps = {
  message?: string | ReactNode;
  children?: ReactNode;
};

export const ModalWarningContent = ({
  message,
  children,
}: ModalWarningContentProps) => {
  const { t } = useTranslation('common');
  const defaultMessage = t('ui.modal.warning');

  return (
    <Flex direction='column' gap={16}>
      <Flex gap={16} align='center' pb={12}>
        <ThemeIcon miw={48} mih={48} bg='red.0' radius={100}>
          <IconAlertTriangle size={32} color='var(--mantine-color-red-7)' />
        </ThemeIcon>

        {typeof message === 'string' ? (
          <Text c='primary.7'>{message || defaultMessage}</Text>
        ) : (
          message || <Text c='primary.7'>{defaultMessage}</Text>
        )}
      </Flex>

      {children && (
        <Flex direction='column' gap={8}>
          {children}
        </Flex>
      )}
    </Flex>
  );
};
